import APICaller from '../library/APICaller'

const CodeServices = {
  /**
   * 그룹 코드 목록 조회
   * @returns {Promise}
   */
  getCommonCodeGroup () {
    return APICaller.get('/api/v1/common-code/groups')
  },
  /**
   * 그룹 코드 등록
   * @param  {String} params.codeGroupId 코드 그룹 아이디
   * @param  {String} params.codeGroupName 코드 그룹명
   * @param  {String} params.groupCodeInfo 그룹 코드 설명
   * @param  {String} params.useYn 사용 여부
   * @return {Promise}
   */
  postCommonCodeGroup ({ codeGroupId, codeGroupName, groupCodeInfo, useYn }) {
    return APICaller.post('/api/v1/common-code/groups', {
      codeGroupId, codeGroupName, groupCodeInfo, useYn
    })
  },
  /**
   * 그룹 코드 수정
   * @param  {String} params.codeGroupId 코드 그룹 아이디
   * @param  {String} params.codeGroupName 코드 그룹명
   * @param  {String} params.groupCodeInfo 그룹 코드 설명
   * @param  {String} params.useYn 사용 여부
   * @return {Promise}
   */
  putCommonCodeGroup ({ codeGroupId, codeGroupName, groupCodeInfo, useYn }) {
    return APICaller.put('/api/v1/common-code/groups', {
      codeGroupId, codeGroupName, groupCodeInfo, useYn
    })
  },
  /**
   * 그룹 코드 목록 조회
   * @param  {String} codeGroupId 코드 그룹 아이디
   * @return  {Primise}
   */
  getCommonCodeGroupDetailWithCodeGroupId (codeGroupId) {
    return APICaller.get(`/api/v1/common-code/groups/${codeGroupId}/details`)
  },
  /**
   * 단일 코드 조회
   * @param {String} codeGroupId 코드 그룹 아이디
   * @param {String} codeId 코드 아이디
   * @return  {Primise}
   */
  getCommonCodeGroupDetailWithCodeGroupIdAndCodeId (codeGroupId, codeId) {
    return APICaller.get(`/api/v1/common-code/groups/${codeGroupId}/detail/${codeId}`)
  },
  /**
   * 단일 코드 등록
   * @param  {String} params.codeGroupId
   * @param  {String} params.codeId
   * @param  {String} params.codeInfo
   * @param  {String} params.codeName
   * @param  {String} params.order
   * @param  {String} params.useYn
   * @return  {Primise}
   */
  postCommonCodeGroupDetail ({ codeGroupId, codeId, codeInfo, codeName, order, useYn }) {
    return APICaller.post('/api/payloadv1/common-code/groups/detail', {
      codeGroupId, codeId, codeInfo, codeName, order, useYn
    })
  },
  /**
   * 단일 코드 수정
   * @param  {String} params.codeGroupId
   * @param  {String} params.codeId
   * @param  {String} params.codeInfo
   * @param  {String} params.codeName
   * @param  {String} params.order
   * @param  {String} params.useYn
   * @return  {Primise}
   */
  putCommonCodeGroupDetail ({ codeGroupId, codeId, codeInfo, codeName, order, useYn }) {
    return APICaller.put('/api/v1/common-code/groups/detail', {
      codeGroupId, codeId, codeInfo, codeName, order, useYn
    })
  }
}

export default CodeServices



// WEBPACK FOOTER //
// ./src/services/CodeServices.js